module.exports = __webpack_public_path__ + "20fdbeed4c9ae8b2a5712c97a86832ab.ttf";